module.exports = __webpack_public_path__ + "img/icon-back.e8586ae7.svg";